import React from 'react'

export default function FixedBar() {
  return (
    <div>   <div className=' hidden md:block flex flex-wrap items-center md:flex md:flex-wrap md:fixed md:left-0 md:bottom-0 w-full justify-center bg-black bg-opacity-50 backdrop-blur-sm items-center z-100  md:space-x-8 p-2 space-x-1 icones '>


    <div className='flex-col flex-wrap items-center justify-center'>
<div className=' rounded  p-4 '>
  <a href="https://www.facebook.com/kerenor.almogi"target='_blank' rel="noreferrer"  className='animated-link'><img src="../../img/facebook.svg" alt="" className=' rounded m-auto ' /></a>
  <p className='text-white  text-center'>Facebook</p>
</div>
  </div>

  <div className='flex-col flex-wrap items-center justify-center'>
<div className='   rounded  p-4'>
  <a href="https://www.instagram.com/kerenor.almogi"><img src="../../img/insta.svg" target='_blank' rel="noreferrer" alt=""  className='rounded m-auto '/></a>
  <p className='text-white text-center '>Instagram</p>
  </div>
  </div>


  <div className='flex-col flex-wrap  items-center justify-center'>
<div className=' rounded  p-4'>
  <a href="https://www.youtube.com/@keren-oralmogi1858"><img src="../../img/YTIcon.svg" target='_blank' rel="noreferrer" alt="" className=' rounded m-auto text-center '/></a>
<p className='text-white text-center'>Youtube</p>
</div>
  </div>

  <div className='flex-col flex-wrap items-center justify-center'>
<div className=' rounded  p-4'>
  <a href="https://wa.me/33603755840"><img src="../../img/WA.svg" target='_blank' alt="" rel="noreferrer" className='text-center m-auto rounded text-center'/></a>
<p className='text-white text-center'>What's App</p>
</div>
  </div>



  <div className='flex-col items-center justify-center '>
<div className=' rounded  p-4'>
  <a href="https://maps.app.goo.gl/E1jXB7edZkAhop6p8"><img src="../../img/maps.svg" target='_blank'  rel="noreferrer" alt="" className=' rounded text-center m-auto'/></a>
<p className='text-white text-center'>Maps</p>
</div>
  </div>

  <div className='flex-col items-center justify-center '>
<div className=' rounded  p-4'>
  <a href="tel:+33603755840"><img src="../../img/tel.svg"  alt="" className=' rounded text-center m-auto'/></a>
<p className='text-white tex-center '>Téléphone</p>
</div>
  </div>

  <div className='flex-col items-center justify-center '>
<div className=' rounded  p-4'>
  <a href="mailto:danse.de.salon.neuvilly@gmail.com"><img src="../../img/mail.svg" target='_blank' rel="noreferrer" alt="" className=' rounded text-center m-auto'/></a>
<p className='text-white text-center'>Mail</p>
</div>
  </div>

</div></div>
  )
}
